import React from 'react';
import { Stack, Text } from '@moda/om';
import { RestAddress } from '../../../hooks/useAddress';
import { ShippingAddressPreview } from '../../ShippingAddress';
import './PayPalShippingAddressPreview.scss';

type Props = {
  address: RestAddress;
};

export const PayPalShippingAddressPreview: React.FC<Props> = ({ address }) => (
  <Stack space={0} className="PayPalShippingAddressPreview">
    <Stack space={1} direction="horizontal" alignItems="center">
      <img
        className="PayPalShippingAddressPreview__logo"
        src="/dist/public/paypal.svg"
        alt="PayPal"
      />
      <Text treatment="eyebrow">Shipping Address</Text>
    </Stack>
    <ShippingAddressPreview attributes={address.attributes} />
  </Stack>
);
